import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TUserClientContact, TUserClientContactPayloadParams, adaptUserClientContactFromResponse } from 'src/store';

import { useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientContactDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_USER_CLIENT}/:client_id/contacts/:id`,
	(payload: TUserClientContactPayloadParams, thunkApi) => {
		const { id, clientId } = payload;
		const path = `${BACKEND_USER_CLIENT}/${clientId}/contacts/${id}`;

		return HttpService.delete(path).then(result => {
			return adaptUserClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item?: TUserClientContact,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientContactDeleteSlice = createSlice({
	name: 'userClientContactDeleteSlice',
	initialState,
	reducers: {
		clearUserClientContactDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientContactDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientContactDeleteApi.fulfilled.type]: (state, action: PayloadAction<TUserClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientContactDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientContactDeleteSelector = () => useAppSelector(state => state[userClientContactDeleteSlice.name]);

export const { clearUserClientContactDelete } = userClientContactDeleteSlice.actions;
